module.exports = {
      id: "icon-login-usage",
      viewBox: "0 0 10.66 10.66",
      url: "/" + "sprite-bc0169963456b1a4ad1bb8f1c406f483.svg#icon-login",
      toString: function () {
        return this.url;
      }
    }